import { atom } from "jotai";

// Official invite code, used as the submit-time fallback when the user leaves
// the (editable, per v2 design) invitation-code field empty.
export const OFFICIAL_INVITE_CODE = "BOE84I";

export interface RegistrationFormData {
  emailOrPhone: string;
  verificationCode: string;
  password: string;
  invitationCode: string;
}

export const initialFormData: RegistrationFormData = {
  emailOrPhone: "",
  verificationCode: "",
  password: "",
  invitationCode: "",
};

export const isRegistrationModalOpenAtom = atom(false);
export const registrationFormDataAtom =
  atom<RegistrationFormData>(initialFormData);
